import { createSelector } from '@reduxjs/toolkit';
import lodashFilter from 'lodash/filter';

import constants from '../../Config/constants';

const cartStatusBlacklist = [
  constants.ORDER_STATUS.CONVERTED,
  constants.ORDER_STATUS.FAILED,
  constants.ORDER_STATUS.EXPIRED,
];

const cartSelector = (state) => state.cart;

const getStoreCartData = (
  cartData,
  storeId,
  types = [constants.CART_TYPE.REGULAR],
) => {
  if (storeId) {
    return lodashFilter(
      cartData,
      (cart) => cart.store_id === storeId && types.includes(cart.type),
    );
  }
  return cartData;
};

const allCartSelector = createSelector(cartSelector, (state) =>
  lodashFilter(
    state?.cartData,
    (cart) =>
      !cartStatusBlacklist.includes(cart.status) &&
      cart.type === constants.CART_TYPE.REGULAR,
  ),
);

const pendingCartSelector = createSelector(allCartSelector, (carts) =>
  lodashFilter(carts, (c) => c.status === constants.ORDER_STATUS.PENDING),
);

const selectCart = createSelector(
  [
    allCartSelector, // base selector
    (_, storeId) => storeId, // for 2nd param
  ],
  getStoreCartData,
);

// return an array for same item with different extras
const selectCartItemVariants = createSelector(
  [
    selectCart, // base selector
    (_, __, itemId) => itemId, // for 2nd (from selectCart) & 3rd param
  ],
  (storeCart, itemId) => {
    const storeCartItems = storeCart?.[0]?.items || [];
    return lodashFilter(storeCartItems, { item_id: itemId }) || [];
  },
);

const selectCartItemTotalQty = createSelector(
  [selectCartItemVariants],
  (cartItems) => cartItems.reduce((acc, obj) => acc + obj.quantity, 0),
);

export {
  allCartSelector,
  pendingCartSelector,
  selectCart,
  selectCartItemTotalQty,
  selectCartItemVariants,
};
